import * as React from 'react'
import styles from '../data.grid.styl'
import cx from 'classnames'
import type {
  ColumnProps,
  ExtCellInfo
} from '../models/column.props.configuration'

export interface SeverityProps<T> {
  row: ExtCellInfo<T>
  column: ColumnProps<T>
}

function Severity<T>({
  row,
  column
}: SeverityProps<T>): React.ReactElement<SeverityProps<T>> {
  return (
    <div
      id="severity"
      className={cx(styles.severityCell, {
        [`${styles.high}`]: column?.severityOptions?.high(row),
        [`${styles.medium}`]: column.severityOptions?.medium(row),
        [`${styles.low}`]: column.severityOptions?.low(row)
      })}
    />
  )
}

export default Severity
